import {EditorLayoutData} from '../types';
import {SceneJsonExporterData} from '../../../@polygonjs/polygonjs/src/engine/io/json/export/Scene';
import {NpmModuleApiController} from './ApiController';
import {
	SceneDataManifestImporter,
	SceneDataElements,
} from '../../../@polygonjs/polygonjs/src/engine/io/manifest/import/SceneData';
// import {StatusCodes} from 'http-status-codes';
import {LoadSceneResponse, LoadDefaultSceneResponse} from './NpmModuleTypes';
import {FeaturesController} from '../core/FeaturesController';

interface LoadData {
	scene_code: SceneJsonExporterData;
	editor_data: EditorLayoutData;
	sceneName: string | null;
}

// const DEFAULT_URL = {
// 	CODE: '/examples/scenes/simple/code.json',
// 	EDITOR: '/examples/scenes/simple/editor.json',
// };

export class NpmModuleSceneLoadController {
	static sceneUrl(sceneName: string | null) {
		const rootUrl = window.location.origin;
		// there are cases where opening the page even with an empty sceneName
		// would load a pre-existing scene. So to be safe, I just remove the scene url param totally
		if (sceneName) {
			const url = `${rootUrl}/?scene=${sceneName}`;
			return url;
		} else {
			return rootUrl;
		}
	}
	static updateUrl(sceneName: string | null) {
		const url = this.sceneUrl(sceneName);
		const urlSceneName = FeaturesController.sceneName();

		// we check first that the new url is different
		// otherwise this forces a full page reload on every scene save
		//if (urlSceneName != window.location.href) {
		// update we now check that the scene names match,
		// so that we can keep url parameters like measurePerformanceOnLoad
		if (urlSceneName != sceneName) {
			(window as any).location = url;
		}

		this.updateDocumentTitle(sceneName);
	}
	static updateDocumentTitle(sceneName: string | null) {
		if (sceneName) {
			document.title = `${sceneName} (Polygonjs Editor)`;
		} else {
			document.title = `Polygonjs Editor`;
		}
	}

	static async load(sceneName: string | null): Promise<LoadData | undefined> {
		const response = await NpmModuleApiController.loadScene(sceneName);

		const json = (await response.json()) as LoadSceneResponse;
		if (json.error) {
			const response_data = json as LoadDefaultSceneResponse;
			const scene_code = response_data.scene.code as SceneJsonExporterData;
			const editor_data = response_data.scene.editor as EditorLayoutData;
			return {scene_code, editor_data, sceneName: null};
		} else {
			const response_data = json as LoadSceneResponse;
			return this._loadFromServer(response_data, sceneName);
		}
	}

	private static async _loadFromServer(data: LoadSceneResponse, sceneName: string | null) {
		if (!(data.manifest && data.editor_data && data.jsons_by_name && data.root && data.ui && data.properties)) {
			alert('it looks like the scene was not saved property');
			return;
			// return this._load_default();
		}

		const assemble_data: SceneDataElements = {
			root: data.root as any,
			properties: data.properties as any,
			ui: data.ui as any,
		};

		const scene_code = await SceneDataManifestImporter.assemble(
			assemble_data,
			Object.keys(data.manifest.nodes),
			data.jsons_by_name
		);

		// note, do not try and display this modal here,
		// as it can't be displayed before the editor is mounted
		// const scenePolygonjsVersion = scene_code.properties?.versions?.polygonjs;
		// if (scenePolygonjsVersion) {
		// 	const currentVersion = NpmModuleSceneSaveController.engineVersion();
		// 	if (currentVersion != scenePolygonjsVersion) {
		// 		const message = `you are loading a scene saved with Polygonjs version ${scenePolygonjsVersion}, but the editor you are loading it with is using version ${currentVersion}. You can proceed and check that your scene works well. But if not, you can load the editor with the same version with 'npx polygonjs-editor@${scenePolygonjsVersion}-1'.`;
		// 		await StoreController.editor.dialog_notice.show({
		// 			title: 'Scene versions conflict',
		// 			message: message,
		// 		});
		// 	}
		// }

		const editor_data = data.editor_data as EditorLayoutData;
		this.updateDocumentTitle(sceneName);
		return {scene_code, editor_data, sceneName};
	}
	// private static async _load_default() {
	// 	const promises = [fetch(DEFAULT_URL.CODE), fetch(DEFAULT_URL.EDITOR)];
	// 	const responses = await Promise.all(promises);
	// 	const [code_response, editor_response] = responses;
	// 	const scene_code = (await code_response.json()) as SceneJsonExporterData;
	// 	const editor_data = (await editor_response.json()) as EditorLayoutData;
	// 	return {scene_code, editor_data};
	// }
}
